// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2XAPG","type":"styles_type__20OIe","choices":"styles_choices__JQCAP"};